import React, { useState } from 'react';
import './whatnext.css';
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../../firebase';


const WhatNext = () => {

    const [nextStep, setnextStep] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [nextStepError, setnextStepError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setnextStepError(''); // Reset nextStep error
        setSuccessMessage(''); // Reset success message

        try {

            // Ajout de l'nextStep à la collection "newsletter" dans Firestore
            await addDoc(collection(db, 'theOrangeWall'), {
                nextStep: nextStep,
                addedAt: new Date(),
            });

            // Réinitialiser l'input et les états après le succès
            setnextStep('');
            setIsLoading(false);
            setIsSuccess(true);
            setSuccessMessage('Ton idée a été ajoutée au mur !.');
        } catch (error) {
            setIsLoading(false);
            setnextStepError('Une erreur est survenue. Veuillez réessayer.');
            console.error('Erreur lors de l\'enregistrement : ', error);
        }
    };

    return (
        <div className='flex flex-col gap-[12px] font-chido bg-offpink xl:rounded-[20px] rounded-[5px] w-full'>

            <p className="lg:text-[65px] text-[16px] xl:pt-[50px] pt-5 text-center text-lifeorange">THE WHAT TO DO NEXT WALL</p>

            <form onSubmit={handleSubmit} className="flex xl:gap-[25px] gap-2.5 xl:p-[50px] p-5 w-full bg-lifeorange xl:rounded-[20px] rounded-[5px]">
                <input className="flex p-3 w-4/6 xl:border-[6px] border-[4px] border-offblack bg-offpink text-offblack xl:rounded-[20px] rounded-[5px] xl:h-[100px] h-auto lg:text-[24px] text-[12px] wninput"
                    type="text"
                    placeholder='TELL US WHAT TO DO NEXT'
                    name="nextStep"
                    value={nextStep}
                    onChange={(e) => setnextStep(e.target.value)}
                    required
                />

                <button className="flex items-center justify-center w-2/6 xl:border-[6px] border-[4px] border-black bg-[#1E1E1E] text-offwhite xl:rounded-[20px] rounded-[5px] xl:h-[100px] h-auto lg:text-[35px]">
                    SEND
                </button>

            </form>

            {/* Affichage du message de succès */}
            {isSuccess && successMessage && (
                <p className="font-concretica text-lightgreen lg:text-[18px] text-[12px] mt-2 px-[50px]">{successMessage}</p>
            )}

            {/* Affichage du message d'erreur */}
            {nextStepError && (
                <p className="font-concretica text-red-500 lg:text-[18px] text-[12px] mt-2 px-[50px]">{nextStepError}</p>
            )}

        </div>
    )
}

export default WhatNext